/**
 * Laat de productvideo afspelen, op de productkaart en op de productpagina.
 *
 * Gedrag, op beide plekken gelijk:
 * - Aanraken start hem, met een korte vertraging. Die vertraging onderscheidt
 *   scrollen van aanraken: wie scrolt raakt de kaart ook aan, maar beweegt meteen.
 *   Gaat de vinger meer dan een paar pixels, dan gebeurt er niets.
 * - Loslaten stopt hem NIET. De video speelt gewoon uit.
 * - Is hij uitgespeeld, dan komt de gewone productfoto terug, tot de volgende
 *   aanraking. Daarom staat "loop" uit.
 * - Op een computer met muis blijft de kaart daarnaast gewoon op hover reageren.
 *
 * Twee dingen die eerder misgingen en hier expres anders staan:
 * 1. Een versie eiste dat de vinger 120 ms stil bleef liggen en wiste de wachttijd
 *    bij touchend. Een gewone tik duurt korter, dus startte er nooit iets. Nu wist
 *    alleen bewegen de wachttijd; loslaten niet.
 * 2. Een versie had een harde apparaatpoort "(hover: hover) and (pointer: fine)"
 *    aan het begin en zette zichzelf daardoor volledig uit op elke laptop met
 *    aanraakscherm. Nu kijken we per gebeurtenis of het een muis is.
 */
(function () {
  if (window.__kaartVideoActief) return;
  window.__kaartVideoActief = true;

  var KAART = '.card-gallery';
  var MEDIA = 'deferred-media';
  var VERTRAGING = 400; // ms vasthouden voordat de video start
  var SPELING = 10; // px die de vinger mag verschuiven voordat het scrollen heet

  var bezig = null; // { soort: 'kaart' | 'media', el: element }

  /* Het meekijkbalkje dat hier stond is weg. Het was er om het afspelen op
     een echte telefoon te kunnen volgen via ?videodebug, en dat werkt
     inmiddels. meld() blijft als lege functie bestaan, zodat de aanroepen
     verderop in dit bestand kunnen blijven staan zonder iets te doen. */
  function meld() {}

  // Afspelen, met opnieuw proberen zodra er beeld is.
  //
  // De video staat op preload="metadata", dus op het moment van aanraken is er nog
  // niets geladen: readyState is 0 en play() wordt dan geweigerd (AbortError). Dat
  // is precies dezelfde fout als eerder bij de hero-video op de telefoon. Daarom
  // eerst load() aanzetten en het bij "loadeddata" en "canplay" nog eens proberen.
  function speel(video) {
    if (!video) return;
    video.loop = false; // uitspelen en dan terug naar de foto

    var klaar = false;

    function opruimen() {
      video.removeEventListener('loadeddata', nogEens);
      video.removeEventListener('canplay', nogEens);
    }

    function gelukt() {
      klaar = true;
      meld('AFSPELEN GELUKT');
      opruimen();
    }

    function nogEens() {
      if (!klaar) probeer();
    }

    function probeer() {
      meld('play(), readyState=' + video.readyState);
      try {
        var belofte = video.play();
        if (belofte && belofte.then) {
          belofte.then(gelukt).catch(function (fout) {
            meld('geweigerd: ' + (fout && fout.name ? fout.name : fout) + ' - wacht op beeld');
          });
        } else {
          gelukt();
        }
      } catch (e) {
        meld('play() wierp een fout: ' + e);
      }
    }

    video.addEventListener('loadeddata', nogEens);
    video.addEventListener('canplay', nogEens);
    try {
      if (video.readyState === 0) video.load();
    } catch (e) {}
    probeer();
  }

  function herstelAnderen(behalve) {
    if (bezig && bezig.el !== behalve) {
      if (bezig.soort === 'kaart') kaartUit(bezig.el);
      else mediaUit(bezig.el);
    }
  }

  /* ------------------------------------------------------ productkaart */

  function kaartVideo(kaart) {
    return kaart ? kaart.querySelector('video[data-kaart-video]') : null;
  }

  // De kaart laten wisselen tussen de productfoto en de video.
  //
  // Bij voorkeur via de methodes van het product-card-component zelf
  // (previewImage / resetImage). Die verwachten alleen een gebeurtenis met
  // pointerType "mouse". Dat is betrouwbaarder dan gebeurtenissen nabootsen:
  // het thema kan zijn luisteraars anders ophangen dan wij verwachten.
  // Lukt dat niet, dan alsnog de gebeurtenissen sturen.
  function kaartComponent(kaart) {
    var el = kaart;
    while (el) {
      if (typeof el.previewImage === 'function' && typeof el.resetImage === 'function') return el;
      el = el.parentElement;
    }
    return null;
  }

  function wissel(kaart, naarVideo) {
    var component = kaartComponent(kaart);
    if (component) {
      try {
        if (naarVideo) component.previewImage({ pointerType: 'mouse' });
        else component.resetImage({ pointerType: 'mouse' });
        return;
      } catch (e) {
        /* valt hieronder terug op de gebeurtenissen */
      }
    }
    try {
      if (naarVideo) {
        kaart.dispatchEvent(new PointerEvent('pointerover', { bubbles: true, pointerType: 'mouse' }));
        kaart.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false, pointerType: 'mouse' }));
      } else {
        kaart.dispatchEvent(new PointerEvent('pointerout', { bubbles: true, pointerType: 'mouse' }));
        kaart.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false, pointerType: 'mouse' }));
      }
    } catch (e) {}
  }

  function kaartAan(kaart) {
    var video = kaartVideo(kaart);
    if (!video) return;
    if (bezig && bezig.el === kaart) return;
    herstelAnderen(kaart);
    bezig = { soort: 'kaart', el: kaart };
    video.classList.add('kaart-video--speelt');
    video.addEventListener('ended', function () {
      meld('uitgespeeld -> terug naar de foto');
      kaartUit(kaart);
    }, { once: true });
    wissel(kaart, true);
    speel(video);
  }

  function kaartUit(kaart) {
    var video = kaartVideo(kaart);
    if (video) {
      video.classList.remove('kaart-video--speelt');
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }
    wissel(kaart, false);
    if (bezig && bezig.el === kaart) bezig = null;
  }

  /* --------------------------------------------------- productpagina */

  // Daar staat de video in een <template> binnen <deferred-media>, met een
  // posterknop ervoor; de component laadt hem pas in bij een klik. Wij gebruiken
  // diezelfde weg en draaien hem daarna terug, zodat de poster terugkomt en een
  // volgende aanraking opnieuw werkt.

  function mediaAan(media) {
    if (bezig && bezig.el === media) return;
    if (!media.querySelector('template')) return;
    herstelAnderen(media);
    bezig = { soort: 'media', el: media };

    var knop = media.querySelector('[ref="deferredMediaPlayButton"]');
    if (knop) knop.click();

    // De component voegt de video toe; even wachten tot hij in de pagina staat.
    setTimeout(function () {
      var video = media.querySelector('video');
      if (!video) {
        meld('FOUT: geen video na klik op de posterknop');
        return;
      }
      video.addEventListener('ended', function () {
        meld('uitgespeeld -> poster terug');
        mediaUit(media);
      }, { once: true });
      speel(video);
    }, 0);
  }

  function mediaUit(media) {
    var video = media.querySelector('video');
    if (video) {
      try {
        video.pause();
      } catch (e) {}
      video.remove();
    }
    media.removeAttribute('data-media-loaded');
    var knop = media.querySelector('[ref="deferredMediaPlayButton"]');
    if (knop) knop.classList.remove('deferred-media__playing');
    if (bezig && bezig.el === media) bezig = null;
  }

  /* ---------------------------------------------------------- de muis */

  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!e.target || !e.target.closest) return;
      var kaart = e.target.closest(KAART);
      if (kaart && kaartVideo(kaart)) kaartAan(kaart);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!e.target || !e.target.closest) return;
      var kaart = e.target.closest(KAART);
      if (!kaart) return;
      // Van het ene naar het andere element binnen dezelfde kaart is geen vertrek.
      if (e.relatedTarget && kaart.contains(e.relatedTarget)) return;
      if (bezig && bezig.el === kaart) kaartUit(kaart);
    },
    { passive: true }
  );

  /* ---------------------------------------------------------- aanraken */

  var wachttijd = null;
  var gestart = false;
  var startX = 0;
  var startY = 0;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var kaart = e.target.closest(KAART);
      if (kaart && !kaartVideo(kaart)) kaart = null;
      var media = kaart ? null : e.target.closest(MEDIA);
      if (!kaart && !media) {
        meld('aangeraakt, maar niet op een kaart of media met video');
        return;
      }

      var aanraking = e.touches && e.touches[0];
      if (!aanraking) return;
      startX = aanraking.clientX;
      startY = aanraking.clientY;
      gestart = false;

      clearTimeout(wachttijd);
      meld('aangeraakt -> ' + (kaart ? 'kaart' : 'productpagina') + ', wacht ' + VERTRAGING + ' ms');
      wachttijd = setTimeout(function () {
        gestart = true;
        meld('lang genoeg vastgehouden, starten');
        if (kaart) kaartAan(kaart);
        else mediaAan(media);
        // Wie bewust vasthoudt wil de video zien, niet doorklikken. De klik die na
        // het loslaten alsnog komt houden we daarom één keer tegen.
        var blokkeer = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        document.addEventListener('click', blokkeer, true);
        setTimeout(function () {
          document.removeEventListener('click', blokkeer, true);
        }, 700);
      }, VERTRAGING);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (gestart) return; // eenmaal begonnen speelt hij gewoon uit
      var aanraking = e.touches && e.touches[0];
      if (!aanraking) return;
      if (
        Math.abs(aanraking.clientX - startX) <= SPELING &&
        Math.abs(aanraking.clientY - startY) <= SPELING
      ) {
        return;
      }
      meld('vinger bewoog -> geannuleerd (scrollen)');
      clearTimeout(wachttijd); // dit was scrollen
    },
    { passive: true }
  );

  // Loslaten vóórdat de wachttijd om is: dat was een gewone tik, en dan hoort de
  // bezoeker gewoon naar het product te gaan. De wachttijd vervalt dus. Is de video
  // eenmaal begonnen, dan stopt loslaten hem niet meer - die speelt uit.
  function losgelaten() {
    if (!gestart) clearTimeout(wachttijd);
  }
  document.addEventListener('touchend', losgelaten, { passive: true });
  document.addEventListener('touchcancel', losgelaten, { passive: true });

  /* ------------------------------- opruimen als het uit beeld schuift */

  if (typeof IntersectionObserver !== 'function') return;

  var opruimer = new IntersectionObserver(
    function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) return;
        if (!bezig || bezig.el !== item.target) return;
        if (bezig.soort === 'kaart') kaartUit(item.target);
        else mediaUit(item.target);
      });
    },
    { threshold: 0 }
  );

  function bekijk() {
    var elementen = document.querySelectorAll(KAART + ', ' + MEDIA);
    for (var i = 0; i < elementen.length; i++) {
      var el = elementen[i];
      if (el.hasAttribute('data-kaart-video-bekeken')) continue;
      if (el.matches(KAART) && !kaartVideo(el)) continue;
      el.setAttribute('data-kaart-video-bekeken', '1');
      opruimer.observe(el);
    }
  }

  bekijk();
  if (typeof MutationObserver === 'function') {
    new MutationObserver(bekijk).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
